import React, { useState, useEffect, FC } from 'react'
import { Modal, Table } from 'antd'
import { Link, useHistory } from 'react-router-dom'
import { SearchBar, EndCustomerAccountForm, Page, useBreakpoints } from '../../components'
import { endCustomerService } from '../../services'
import { EndCustomer, EndCustomerFormValues } from '../../types'
import styles from './index.module.less'

const { Column } = Table

const EndCustomers: FC = () => {
	const [isVisible, setIsVisible] = useState<boolean>(false)
	const [filter, setFilter] = useState<string>('')
	const [customers, setCustomers] = useState<EndCustomer[]>([])
	const [isLoading, setIsLoading] = useState<boolean>(false)
	const history = useHistory()
	const breakpoints = useBreakpoints()

	const createEndCustomer = async (values: EndCustomerFormValues): Promise<void> => {
		const { data } = await endCustomerService.create(values)
		setIsVisible(false)
		history.push(`/endcustomer/${data.id}/licenses`)
	}

	useEffect(() => {
		const initEndCustomers = async (): Promise<void> => {
			setIsLoading(true)
			const { data } = await endCustomerService.getAll()
			setCustomers(data)
			setIsLoading(false)
		}

		initEndCustomers()
	}, [])

	return (
		<Page title='End Customers'>
			<SearchBar
				className={styles.search}
				placeholder='Filter by name'
				search={setFilter}
				buttonProps={{
					onClick: (): void => setIsVisible(true),
					children: 'New end customer',
					icon: 'plus'
				}}
			/>
			<Table
				dataSource={filter.length ? customers.filter(ec => ec.name.toLowerCase().includes(filter.toLowerCase())) : customers}
				loading={isLoading}
				rowKey='id'
			>
				<Column
					title='Name'
					dataIndex='name'
					render={(name: string, record: EndCustomer): React.ReactNode => <Link to={`/endcustomer/${record.id}/licenses`}>{record.name}</Link>}
				/>
			</Table>
			<Modal centered={breakpoints.md} visible={isVisible} onCancel={(): void => setIsVisible(false)} title={`Create new end customer`} footer={null}>
				<EndCustomerAccountForm submit={createEndCustomer} />
			</Modal>
		</Page>
	)
}

export default EndCustomers
